var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIrl(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 48,
    viewBox: "0 0 71 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.50999 0.24999C2.99746 0.24999 0.149994 3.09746 0.149994 6.60999V40.88C0.149994 44.3925 2.99746 47.24 6.50999 47.24H23.51C23.51 31.5733 23.51 15.9067 23.51 0.23999L6.50999 0.24999Z",
    fill: "#169B62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.49 0.25C23.49 15.9167 23.49 31.5833 23.49 47.25H46.84C46.84 31.5833 46.84 15.9167 46.84 0.25H23.49Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.78 0.25H46.83C46.83 15.9167 46.83 31.5833 46.83 47.25H63.78C67.2925 47.25 70.14 44.4025 70.14 40.89V6.61C70.14 3.09747 67.2925 0.25 63.78 0.25Z",
    fill: "#FF883E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIrl);
export default __webpack_public_path__ + "static/media/IRL.50e39125d686f48df524b4b1f3e059fd.svg";
export { ForwardRef as ReactComponent };